// extracted by mini-css-extract-plugin
export default {"filter":"ProductFilter_filter__2cbPC","category":"ProductFilter_category__7ircx","brand":"ProductFilter_brand__gDPeq","active":"ProductFilter_active__p0qTb"};